export default __webpack_public_path__ + "static/media/LEAFLETS 2025 MARCH 26.51b41ede.pdf";